import React from 'react';

function Header() {
  return (
    <header className="mb-0 text-white text-center"></header>
  );
}

export default Header;
